import { NotificationBell } from "../controls/NotificationBell";
import { LangToggle } from "../controls/Toggles";

// home page only: language on top, notifications right below
export const ControlRail = () => (
  <div className="absolute left-0 top-0 z-30 flex flex-col items-start gap-2 lg:left-2" data-testid="control-rail">
    <LangToggle />
    <NotificationBell />
  </div>
);
